import { useLocation, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import MainHeading from "../../../components/comman/MainHeading";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function SiteSalaryHead() {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    SiteSalaryHeadData: [],
    searchQuery: "",
    downloadLoading: false,
  });

  useEffect(() => {
    GetSiteSalaryHead();
  }, [
    pageStates?.searchQuery,
    pageStates?.currentPage,
    pageStates.pageSize,
    location?.state?.data?.type,
    filterDetails?.orderBy,
  ]);

  const GetSiteSalaryHead = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site_salary_head +
      `?` +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }) +
      `&type=${location?.state?.data?.type}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.siteSalaryHead?.map((item) => ({
          ...item,
          companyName: item?.Company?.name,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          SiteSalaryHeadData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleExportExel = (item) => {
    let data = {
      exportDataType: "siteSalaryHead",
      siteId: item?.id,
    };
    ExportDataHandler(data);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_site_salary_head, { state: { data: data } });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Site Name" },
    { value: "companyName", label: "Company" },
  ];

  const ActionData = [
    // {
    //   label: "Download",
    //   className: "btn btn-link",
    //   icon: <DownloadIcon />,
    //   title: "Download",
    //   clickHandler: handleExportExel,
    // },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <MainHeading
          title={"Site Salary Head"}
        // buttonText={"Add"}
        // buttonIcon={<PlusIcon />}
        // buttonLink={RoutesLink?.add_site_salary_head}
        // state={{ SiteSalaryHeadData: pageStates?.SiteSalaryHeadData }}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              searchPlaceHolder={"Search By Site Name"}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.SiteSalaryHeadData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </>
    </>
  );
}
